import {initLabelSidebar} from "./label#sidebar";
import {SIDEBAR} from "../../constants";
import {initDivTime} from "./div.time";
import {getSize} from "./getSize";

export const initAsideSidebar = () => {
	if ( SIDEBAR.NODE )
	{
		const label = SIDEBAR.NODE.querySelector(`label[for="sidebar"]`);
		const content = SIDEBAR.NODE.querySelector(`div.content`);
		const customScrollbar = SIDEBAR.NODE.querySelector(`div.managers-scrollbar > span`);
		const timeCounter = SIDEBAR.NODE.querySelector(`div.time time`);
		const timeIcons = SIDEBAR.NODE.querySelector(`div.time div.icons`);
		
		customScrollbar.style.height = getSize(content.offsetHeight, content.scrollHeight);
		
		content.addEventListener(`scroll`, () => {
			customScrollbar.style.top = getSize(content.scrollTop, content.scrollHeight);
		});
		
		initDivTime(timeCounter, timeIcons);
		
		initLabelSidebar(label);
		
		SIDEBAR.OPTIONS = {
			content,
			customScrollbar,
			changeSize()
			{
				this.customScrollbar.style.height = getSize(this.content.offsetHeight, this.content.scrollHeight);
				this.customScrollbar.style.top = getSize(this.content.scrollTop, this.content.scrollHeight);
			},
		};
	}
};
